// 菜单栏状态 滚动样式 默认展示样式
const BAR_MENU_STATUS = {
  default: 'default',
  scroll: 'scroll'
};

const DESCRIPTION = [
  {
    id: 'about',
    title: '企业介绍',
    desc: [
      '掌阅科技股份有限公司（603533.SH）以“让创作点亮美好时光”为使命，是国内领先的以数字阅读为基础、IP衍生开发为核心、人工智能技术为支撑的多模态内容生产运营平台。公司以“自驱敢为、客观坦诚、简单高效、追求极致”的“掌阅范”为行为准则，为全球用户提供数字阅读、短剧等优质文化产品和服务。公司产品矩阵涵盖掌阅、掌阅精选、得间小说等阅读平台，速看短剧等短剧平台，并通过海外阅读平台 iReader 和短剧平台 iDrama 积极推动中华文化出海。',
      '2017年9月21日，公司在上海证券交易所挂牌上市，股票代码 603533。'
    ]
  },
  {
    id: 'reading',
    title: '智能阅读',
    desc: [
      '掌阅自成立以来，专注于数字阅读和衍生业务领域，凭借产品体验和先发优势，逐步成为数字阅读和衍生业务领域中的领先者。公司持续强化数字阅读平台内容生态建设，进一步提升内容生产能力，内容竞争力不断增强，拥有出版、原创文学、有声、漫画等丰富而优质的数字内容资源，旗下阅读产品和平台包括掌阅App、掌阅精选阅读服务、得间小说App等。'
    ]
  },
  {
    id: 'drama',
    title: '品质短剧',
    desc: [
      '掌阅基于海量版权资源开展短剧业务，积极拓展以IP为核心的短剧内容生产、制作与运营，迅速实现了从剧本创作、拍摄剪辑、发行销售全链路一体化建设，通过数字阅读与衍生业务的融合发展，提升IP的生命力和商业价值。作为公司第一大业务板块，掌阅短剧已进入行业第一阵营，涵盖版权、自制、合制、付费投放、官方发行等多种形态，涉及都市、玄幻、校园、推理悬疑、历史、言情、幻想等多种题材。基于多模态大模型的快速发展，公司积极布局AI短剧，已推出AI类真人风格短剧及转绘AI动漫短剧，积累制作经验、完善供应链，探索打通AI短剧的商业化通道。'
    ],
    desc_wap: [
      '基于海量版权资源拓展以IP为核心的短剧内容生产、制作与运营，打造优质短剧内容品牌，提升IP生命力和商业价值。'
    ]
  },
  {
    id: 'oversea',
    title: '文化出海',
    desc: [
      '为提升中华文化海外影响力，积极响应文化“走出去”战略，掌阅于2015年推出掌阅国际版iReader APP，成为国内首个出海的数字阅读品牌，现已覆盖全球150多个国家和地区。为满足不断增长的海外市场需求，掌阅自主开发了协作式翻译平台和工具“掌阅翻译猿”，不断提高网文、短剧、漫画等内容的翻译速度和质量。2025年初，掌阅推出海外短剧平台iDrama，率先上线英语、日语、韩语三个语种版本，用户增长迅速，成为中国短剧出海的新锐力量。'
    ]
  }
];

const READING_APPS = [
  {
    id: 'zhangyue',
    name: '掌阅APP',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/961871fc-2373-405b-b092-79f3668241a0.png',
    desc: [
      '掌阅App是由掌阅科技推出的一款电子阅读手机App，拥有出版、原创文学、有声书、漫画、杂志等海量正版内容，优质好书覆盖率处于行业领先水平，并在业内率先实现了3D仿真翻页、护眼模式等技术的创新与引用，在文档识别、转化、续读以及精排版等方面形成了核心技术优势，为读者提供优质便捷的智能阅读服务。',
      '人工智能时代，公司积极探索AI大模型在阅读领域的垂直应用，上线“掌阅AI辅助阅读”功能，提升阅读效率和用户体验。同时配套推出掌阅App网页版，实现跨设备同步，满足用户不同阅读场景需求。'
    ],
    desc_wap: [
      '拥有出版、原创文学、有声书、漫画等海量正版内容及行业领先的核心技术优势，推出“掌阅AI辅助阅读”功能，多端同步，为读者提供优质便捷的智能阅读服务。'
    ],
    qrcode: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/e4006452-babb-4ba0-af53-1a3d2db2d768.png',
    web: {
      name: '掌阅网页版',
      name_wap: '网页版',
      url: 'https://pc.ireader.com/'
    },
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/e05bac5a-ec15-424b-829a-c2d84f47d09a.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/ba7a3f27-f867-403f-9ab2-b4e2b45440d7.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1a746c4a-7dee-428a-bb97-24e7ff316520.png'
    ],
    download: 'https://qr.ireader.com/pve66'
  },
  {
    id: 'selected',
    name: '掌阅精选',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/42155ce7-75ae-45e6-9d47-804baf61c575.png',
    desc: [
      '掌阅精选是掌阅科技旗下专注为机构提供数字图书馆和阅读解决方案的品牌。',
      '精选数十万册优质出版好书、有声书等高品质内容，覆盖手机端、电脑端、阅读器、借阅一体机等多种终端，提供定制化电子书数据库、职工电子书屋、数字阅读平台、智慧图书馆等多个阅读场景，打造软件与硬件相结合的创新数字阅读空间，帮助机构用户提升使用效能。',
      '目前掌阅精选H5页面已上线“AI阅读助手”功能，赋能找书、读书、用书全场景，实现阅读体验和效率双提升。'
    ],
    desc_wap: [
      '专注为机构提供数字图书馆和阅读解决方案，精选高品质内容，覆盖手机、电脑、阅读器等终端，打造软硬件相结合的创新数字阅读空间。'
    ],
    qrcode: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f0f3c70a-ae25-4a01-9a7f-2f47cf23bd9d.png',
    web: {
      name: '掌阅精选官网',
      name_wap: '官网',
      url: 'https://select.zhangyue.com/'
    },
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/21e56751-ab09-4a43-873a-b93bde02d0f4.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/e21f64e3-c4af-42a5-aa48-4a740a8ac2e0.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/9cd319b9-ee39-41cc-a29f-2118fc93fb4e.png'
    ],
    download: 'https://select.zhangyue.com/'
  },
  {
    id: 'dejian',
    name: '得间小说',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1dd4e394-d2c5-4078-957f-aaaf9d7c79f2.png',
    desc: [
      '得间小说是掌阅科技旗下专注免费正版、品质阅读的产品。',
      '包含出版、原创文学、漫画等全品类热门书籍，以及精品短剧内容，覆盖历史、科幻、都市、玄幻、言情、仙侠等多种题材。'
    ],
    desc_wap: [
      '得间小说是掌阅科技旗下专注免费正版、品质阅读的产品。包含出版、原创文学、漫画等全品类热门书籍，以及精品短剧内容，覆盖历史、科幻、都市、玄幻、言情、仙侠等多种题材。'
    ],
    qrcode: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/812d52b0-2f0c-4553-b018-3d6f835540af.png',
    web: {
      name: '得间小说官网',
      name_wap: '官网',
      url: 'https://www.idejian.com/'
    },
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/5c376047-8a9c-47aa-a571-4c398298eee0.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/594d5f4e-a775-455e-aa97-618b29a13976.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bb224090-12b1-40d8-b817-ddacda03803a.png'
    ],
    download: 'http://www.djread.cn/'
  },
  {
    id: 'anime',
    name: '掌阅动漫',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/9ad7770a-a68d-4d43-ae5f-29e0ffa8c2a2.png',
    desc: [
      '掌阅书城上线漫画总量近2000部，覆盖国内百余家版权方。',
      '旗下作品《仙帝归来》《凌天神帝》《绝世武魂》《武映三千道》《逆天至尊》《一品嫡女》《重生八万年》《独步逍遥》《我被封印九亿次》等多部改编漫画作品打入日韩漫画排行榜；《灵剑尊》《独步逍遥》《绝世武魂》《武神主宰》等IP改编动漫作品在线播放量均超10亿；动漫作品《元龙》上线后蝉联多榜热搜第一，实现了流量与口碑的双丰收。'
    ],
    desc_wap: ['覆盖国内百余家版权方精品漫画内容，多部改编漫画及动漫作品获得国内外多平台认可，实现流量与口碑双丰收。'],
    qrcode: '',
    web: {
      name: '漫画官网',
      name_wap: '漫画官网',
      url: 'http://cm233.zhangyue.com/'
    },
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d0f22503-738c-45f8-906e-9765b1db8bf8.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/22c2b43c-0d49-4d69-a4bf-360bf5bf32e7.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/7650d86b-871f-4ce5-a654-2a2ac76f2650.png'
    ],
    download: ''
  }
];

const OVERSEA_APPS = [
  {
    id: 'ireader',
    name: '国际版iReader',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/fa7e597d-52b2-426d-a54a-4ff5a61d1a93.png',
    desc: [
      '作为国内首个出海的数字阅读品牌， 掌阅国际版iReader APP 于2015年推出至今，已覆盖全球150多个国家和地区，40多个“一带一路”沿线国家，向海外用户发售全球版权书籍，支持汉语（简体、繁体）、英语、法语、西班牙语、泰语、韩语等多个语种，在多个国家的Google Play和APP Store市场中长期稳居前列，并围绕核心产品链路不断优化用户体验。',
      '公司持续强化海外内容体系建构，打造符合当地文化背景的精品内容，2020年新增海外原创业务，帮助海外本土作家进行高水平网络文学创作，多维度满足不同国家与地区的用户需求。'
    ],
    desc_wap: [
      '国际版iReader APP 已覆盖全球150多个国家和地区，支持汉语（简体、繁体）、英语、法语、西班牙语、泰语、韩语等多个语种，并推出海外原创业务平台。'
    ],
    qrcode: '',
    web: null,
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/e8d792a2-0fc5-4954-b594-f058a576d6f9.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/572b8370-fddb-4863-8057-bfd01ea9f9e5.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d46165c3-32c7-47b3-8e89-31aace25488b.png'
    ]
  },
  {
    id: 'drama',
    name: 'iDrama',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/795c6ce1-16d2-4c30-b03a-2bbf0dc5ff07.png',
    desc: [
      '掌阅海外短剧平台iDrama致力于为全球用户提供优质短剧内容及服务，已率先上线英语、日语、韩语三个语种版本，逐步覆盖西班牙语、葡萄牙语、法语、泰语等多语种。',
      '上线以来，iDrama用户增长迅速，在美国、韩国、印度尼西亚、马来西亚、印度等市场表现突出，多次跻身App Store与Google Play娱乐类畅销榜TOP 50，核心付费指标稳居行业前列，成为中国短剧出海的新锐力量。'
    ],
    desc_wap: ['iDrama已上线英、日、韩语种版本，逐步覆盖西、葡、法、泰等多语种，成为中国短剧出海的新锐力量。'],
    qrcode: '',
    web: null,
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1693b67d-0f85-429d-91f4-8c45395f33d2.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d8249d4e-7ab0-4c17-a39a-3a0cf984fd4c.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f7647545-1a84-45c0-9499-4118a16d7ad8.png'
    ]
  },
  {
    id: 'monkey',
    name: '掌阅翻译猿',
    logo: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/mini_video/bc8c278d-c266-46de-9737-ad17a418c020.png',
    desc: [
      '掌阅高度重视出海内容质量和海外用户体验，为了更好地满足不断增长的海外市场需求，公司自主开发了协作式翻译平台和工具“掌阅翻译猿”，根据各大出海平台的市场定位和内容要求，提供灵活的翻译服务解决方案，支持英、西、葡、法、韩、日、泰、印尼、越南等多种语言。',
      '平台拥有专业语言背景的国内译员和海外本土译员，具备扎实的专业背景和丰富的翻译经验，持续为网文、短剧和漫画等内容提供优质稳定的翻译和配音等本地化服务。'
    ],
    desc_wap: [
      '自主研发的协作式翻译平台和工具，支持英、西、葡、法、韩、日、泰、印尼、越南等多种语言，为网文、短剧、漫画等内容提供优质稳定的翻译和配音等本地化服务。'
    ],
    qrcode: '',
    web: null,
    imgs: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/mini_video/eff93b14-6e67-4300-9595-1cc5664aa693.png'
    ],
    imgs_wap: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f334c6a4-57fc-4797-ac03-50cd4abcbc96.png'
    ]
  }
];

// 导航数据
const NAV = [
  {
    name: '关于我们',
    id: 'about',
    nav: true,
    data: DESCRIPTION[0],
    component: 'Description'
  },
  {
    name: '',
    id: 'introduction',
    nav: false,
    component: 'Introduction'
  },
  {
    name: '智能阅读',
    id: 'reading',
    nav: true,
    data: DESCRIPTION[1],
    component: 'Description'
  },
  {
    name: '版权内容',
    id: 'copyright',
    nav: false,
    type: 'mobile',
    component: 'Copyright'
  },
  {
    name: '版权内容PC',
    id: 'copyrightPC',
    nav: false,
    type: 'pc',
    component: 'CopyrightPC'
  },
  {
    name: '',
    id: 'readingPC',
    nav: false,
    type: 'pc',
    data: READING_APPS,
    component: 'ApplicationPC'
  },
  {
    name: '阅读产品',
    id: 'reading',
    nav: false,
    type: 'mobile',
    data: READING_APPS,
    component: 'Application'
  },
  {
    name: '品质短剧',
    id: 'drama',
    nav: true,
    data: DESCRIPTION[2],
    component: 'Description'
  },
  {
    name: '',
    id: 'dramaPC',
    nav: false,
    type: 'pc',
    component: 'DramaPC'
  },
  {
    name: '',
    id: 'drama',
    nav: false,
    type: 'mobile',
    component: 'Drama'
  },
  {
    name: '',
    id: 'label',
    nav: false,
    component: 'Label'
  },
  {
    name: '文化出海',
    id: 'oversea',
    nav: true,
    data: DESCRIPTION[3],
    component: 'Description'
  },
  {
    name: '海外产品',
    id: 'overseaapp',
    nav: false,
    type: 'mobile',
    data: OVERSEA_APPS,
    component: 'Application'
  },
  {
    name: '',
    id: 'overseaPC',
    nav: false,
    type: 'pc',
    data: OVERSEA_APPS,
    component: 'ApplicationPC'
  },
  {
    name: '新闻中心',
    id: 'news',
    nav: true,
    component: 'News'
  },
  {
    name: '投资者关系',
    id: 'investment',
    nav: true,
    component: 'Investment'
  },
  {
    name: '社会责任',
    id: 'responsibility',
    nav: true,
    component: 'Responsibility'
  },
  {
    name: '联系我们',
    nav: true,
    id: 'contact'
  }
];

// 版权内容 (后续会改为动态配置)
const COPYRIGHT = [
  {
    id: 'quality',
    name: '品质出版',
    // div分隔，拆成数组
    desc: [
      '掌阅与各大出版社、图书公司建立了长期稳定的数字版权内容合作，力求使读者第一时间获取新书、好书，现已积累海量出版物，内容覆盖通俗小说、严肃文学、历史社科、经济管理等诸多题材，如金庸作品集、《三体》《明朝那些事儿》《百年孤独》《麦田里的守望者》等；也包括诺贝尔文学奖、茅盾文学奖等经典作品，如莫言作品集、《繁花》《平凡的世界》等；并曾独家首发《卧虎藏龙》《围城》《企鹅全球史》《陈寅恪的最后20年》等佳作。',
      '此外还与国际出版巨头“企鹅兰登”公司展开全量合作，可满足读者的外语原版书阅读需求。'
    ],
    pics: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/b501d1c9-06d1-492f-b977-b4bd90cd75f7.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/3f3b79c8-eb47-4438-8075-9df0369c5e4b.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/91eee22a-3736-4469-96cb-8192876c10a1.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/fa69ec59-5779-41ec-b3c8-f5f2d206cbe5.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/12a0c46d-bb13-40da-a66e-1bdd3d4b64b9.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/586f2f7b-ab0b-402f-9088-ea36ba6b4c9b.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/69c58cc2-d659-4a86-80fe-71b83e3525e9.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/4755fc83-2736-480b-9c79-ab94beb65284.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/88e42d85-95e8-40ce-a027-900e1d2f20f4.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/627b24eb-6336-42f0-8731-5b7ee5c22e33.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/b1e2ff32-7944-4298-8d16-022551287e23.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/609abfab-7584-41f2-82e6-9eae0702d1d7.png'
    ]
  },
  {
    id: 'original',
    name: '原创文学',
    desc: [
      '掌阅文学成立于2015年，是掌阅自有内容的生产和孵化中心。旗下涵盖多家原创平台，包括掌阅文化（掌阅小说网、书山中文网）、红薯网、趣阅科技（趣阅小说网、神起中文网）、有乐中文网、速更小说、魔情等。',
      '掌阅文学在为作者打造优质创作环境的同时，通过运营原创网络文学版权，向阅读、影视、动漫等各类文化娱乐类客户输出内容价值和 IP 价值，携手多家影视、游戏公司及视频平台，实现创作、孵化、影漫游等衍生开发一体化，实现内容生态的良性发展。'
    ],
    pics: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/3ebfbe39-14c4-4af1-9aa8-a169d46d5e79.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/348047f6-ba55-4ad6-9546-819e80a9c777.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/601823bb-36b4-4cf8-a30b-d80ff5e7a956.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/76be997b-4d44-4534-809d-5c55eb174328.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/7793ec61-77f1-408d-ac34-93803b39c9aa.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/2e7e9cd1-ff07-45e0-8210-76083f7bc042.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/483a94fe-08d1-4fc7-a5cc-b489393e63f9.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/018ecc09-02ba-490f-89e5-59f7fe610d81.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/c7133be8-5912-488a-93f5-2d50160dc673.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/c6ec3be9-e00c-4b2b-a7cc-e2a5228d7daf.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/4a685a45-e3a1-4dbd-84c1-6f92610bf679.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/fb65df4b-369e-4536-9915-73f4dec91051.png'
    ]
  },
  {
    id: 'audio',
    name: '有声听书',
    desc: [
      '掌阅有声始终坚持精品化路线，内容包括版权引入以及掌阅自制原创有声小说，目前已积累近100万小时的有声内容，包括有声小说（出版、网文）、亲子儿童、相声评书等在内的海量优质正版内容。',
      '如《围城》《三体》《人类简史》《美国陷阱》《白鹿原》《金庸作品全集》《法医秦明大合集》《梁晓声作品集》《穷查理宝典》等品质有声内容，《蜜汁炖鱿鱼》《破冰行动》《大江大河》《云边有个小卖部》等热门影视有声书。'
    ],
    pics: [
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f2cd60d0-4b5c-4045-822f-8dae013d5a93.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/6c7b3e56-bd04-40ec-bc7d-340325239534.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/436a1e46-d417-41a3-b52e-f88db4cce39b.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/9e794774-d730-4b4a-8a68-6840ce146546.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/e0f99397-c693-4cbe-876b-8166cf101937.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/99570ad8-e62b-42d9-9430-1b2f7be7992e.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bd190443-21d3-44ff-ba5e-57f7cd656bb5.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/0f15d6fd-ffac-4d87-9c3b-e2a05b1d37b5.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/c4f37eef-a85a-4814-ae94-6fd11d94d8ae.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/6fca2d2a-a299-472a-a5da-c812b1ca374b.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d818d99a-41ca-4407-a875-48ac8f7e262f.png',
      'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/826a3b2a-ef5d-4123-8954-fdf3c1118822.png'
    ]
  }
];

// 联系方式
const CONTACT = [
  {
    type: 'service',
    name: '客服热线',
    info: '400 881 3311（8:00~22:00）',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/04fcae7c-221f-4a71-b2b0-634978b5ce84.png'
  },
  {
    type: 'address',
    name: '办公地址',
    info: '北京市朝阳区四惠东通惠河南岸四惠大厦2层2029E',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bae76df5-ad42-4d9c-bcce-6fb16037cd66.png'
  },
  {
    type: 'phone',
    name: '总机',
    info: '010-59231388',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/92695fda-e038-4cd7-900f-3a55eb9e4f0d.png'
  },
  {
    type: 'fax',
    name: '传真',
    info: '010-59231388-802',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1c323ece-3849-4e8a-8adc-28dbf28f8554.png'
  }
];

const RESPONSIBILITY = {
  desc: [
    '掌阅成立至今，积极践行企业社会责任，策划执行了多项公益活动。特别是2018年至今，先后策划推出致力于改善农村及贫困地区青少年课外阅读内容匮乏、助力提升全民阅读的“全民阅读∙文化筑梦”社会公益项目，关爱作家群体、提供保障的“心源计划”，以及助力残疾人群体实现就业、摆脱贫困的“助残扶智∙居家就业”公益项目等。',
    '2020年初，为助力新冠疫情防治工作，公司在掌阅APP第一时间免费开放了新型冠病毒感染防护知识及多种防疫相关的书籍，并向湖北省人民医院和武汉大学中南医院两所医院共捐助200万元，用于湖北省疫情防治工作。同时，掌阅还为湖北读者免费提供了100万份掌阅APP月卡VIP，读者可免费畅读20万册图书一个月。'
  ],
  list: [
    {
      id: 'resp1',
      title: '全民阅读  文化筑梦',
      img: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/49499f7e-1f60-4006-a152-9c720782fc17.png'
    },
    {
      id: 'resp2',
      title: '助残扶智  居家就业',
      img: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/3eef08a3-c556-4673-8cb6-5206e89cbaff.png'
    },
    {
      id: 'resp3',
      title: '助梦远航  心源计划',
      img: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bb33f260-5c61-4194-8b5d-64fdcafb5f20.png'
    },
    {
      id: 'resp4',
      title: '掌阅公版',
      img: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/cf52283b-7bc7-4a65-950d-9da42e5dd7c7.png'
    }
  ]
};

const INVESTMENT = {
  title: '投资者关系',
  desc: '2017年9月21日，掌阅科技股份有限公司在上海证券交易所挂牌上市，股票代码603533。',
  bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/c237ab52-f422-4f7b-8e47-a5d1577f3efc.png',
  bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/3134c834-0ee6-40ac-8d74-f2fc63bc8b59.png',
  list: [
    {
      name: '公司公告',
      href: 'http://www.sse.com.cn/assortment/stock/list/info/announcement/index.shtml?productId=603533'
    },
    {
      name: '股价信息',
      href: 'http://www.sse.com.cn/assortment/stock/list/info/price/index.shtml?COMPANY_CODE=603533'
    },
    {
      name: '投资者互动',
      href: 'http://sns.sseinfo.com/company.do?stockcode=603533'
    }
  ],
  contact: [
    {
      name: '电话',
      text: '（8610）59236288',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/769921a3-3f30-4c9e-bc7d-072f6618084b.png'
    },
    {
      name: '传真',
      text: '（8610）59231388-802',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/5a91969d-0006-432a-b3d4-e3bab384df57.png'
    },
    {
      name: '邮箱',
      text: 'ir@zhangyue.com',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/b68e558c-a118-433b-afd5-2cd3ae67dd01.png'
    }
  ]
};

const CULTURE = {
  bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/3864a564-1267-4d31-b795-a83daf669ec3.png',
  bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/9b31eefe-9576-4cb4-95f1-4eef3f7c3d96.png',
  list: [
    {
      name: '自驱敢为',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/6fbd1bbb-ca9c-439d-ab33-919b00d8d0f1.png',
      desc: ['对待自己：', '渴望成功，有责任心', '主动进取，突破舒适区', ' 勇于担当，勇于表达', '积极影响，打破定式']
    },
    {
      name: '客观坦诚',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/4f21b3fe-245b-425c-98fe-cbe4152350b7.png',
      desc: ['对待他人：', ' 深入本源，尊重事实', '不自嗨，不包装', '当面表达真实想法', '言行一致']
    },
    {
      name: '简单高效',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1312af42-f793-458a-868d-83612fed5b7b.png',
      desc: ['对待组织：', '人际关系简单，没包袱', '高效协同', '流程规则简洁清晰', '不冗余']
    },
    {
      name: '追求极致',
      icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/148a29b5-5639-4538-b0a8-536b4d70f8fd.png',
      desc: ['对待事情：', '不放过问题', '更大范围找最优解', '不断挑战更高标准']
    }
  ]
};

const SHARE = [
  {
    type: 'weixin',
    name: '掌阅官方微信公众号',
    qrcode: '//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/zy_qrcode.b742287c.png',
    icon: '//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/wechat.f8da06b4.png'
  },
  {
    type: 'weibo',
    name: '掌阅官方微博',
    href: 'https://weibo.com/zhangyuesc',
    icon: '//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/wb.10b73672.png'
  }
];

const ICP = [
  {
    name: '京ICP证090653号',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/8.png'
  },
  {
    name: '网络出版服务许可证 （总）网出证（京）字第 143 号 ',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/6.png'
  },
  {
    name: '京网文（2023）0461-011号',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/2.png'
  },
  {
    name: '京ICP备11008516号',
    href: 'https://beian.miit.gov.cn/'
  },
  {
    name: '京公网安备11010502030453号',
    href: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030453'
  },
  {
    name: '营业执照',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/1.png'
  },
  {
    name: '广播电视节目制作经营许可证',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/4.png'
  },
  {
    name: '电子出版物制作许可证',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/5.png'
  },
  {
    name: '出版物经营许可证',
    href: 'https://static-efe-front-h.zhangyuecdn.com/licenses/prod/65e15f3b4298ba00553d1a10/7.png'
  }
];

const POLICY = [
  {
    name: '法律声明',
    id: 'terms?id=contact'
  },
  {
    name: '版权声明',
    id: 'copyright?id=contact'
  },
  {
    name: '隐私策略',
    id: 'privacy?id=contact'
  }
];

const LABEL = {
  PC: [
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/fa785401-96dd-4199-b1a1-dcdb71a5e9fd.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/718d3431-d9f8-4098-8309-53c1eac772b7.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/10e5cc71-5a05-4d39-a027-0f699b57280b.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/385152eb-dd4f-4996-8f60-216ed1e2f9e8.png'
  ],
  WAP: [
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/38be6920-ce50-4a43-91fc-70e3356eb898.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/580cf129-2949-4955-96a3-ccafefd72c2c.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/795a4608-ca94-4d15-8768-ad78a452d91a.png',
    'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/7fd7016a-d8a3-498f-aa08-51eb18472982.png'
  ]
};

const ADVANTAGE = [
  {
    id: 'content',
    name: '海量内容',
    desc: '掌阅以出版社、版权机构、文学网站、作家为海量正版数字内容来源，包括图书、有声读物、杂志、漫画、自出版等多种类型的数字出版物，持续引进精品内容，对优质重磅书始终保持较高的覆盖比例，同时上线“新时代 新经典——学习习近平新时代中国特色社会主义思想重点数字图书专栏”，具有丰富权威的党建学习资源。大力发展“掌阅文学”内容孵化生态体系，通过挖掘、签约、培养、推荐、衍生增值等手段向市场输出优质原创内容。积极拓展以IP为核心的短剧内容生产、制作与运营，针对年轻用户群体，开发爱情、校园、职场等能引发强烈情感共鸣的题材，同时融入励志、生活纪实、社会热点等内容，提升剧集的文化内涵和社会影响力。',
    bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/928435a7-07c9-4ecb-afa1-432d99581b84.png',
    bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1dd139cc-b9cc-47e7-ae37-74d6113bd958.png',
    href: '/advantage?id=0'
  },
  {
    id: 'derivative',
    name: '多元衍生',
    desc: '掌阅积极拓展以IP为核心的有声、影视、短剧、游戏、动漫等衍生业务，以系统化、高质量的内容生产、制作和运营，连接IP衍生授权的上下游资源，持续稳定地为用户提供丰富多元的精品内容，通过数字阅读与衍生业务的融合发展，提升IP的生命力和商业价值。其中，短剧已成为公司第一大业务板块，进入市场第一阵营，构建起“国内扩张、海外突破”的双轮驱动格局，依托人工智能技术构建全链路智能化生产运营系统，以优秀的人文内涵与精良的制作水准，实现社会价值与商业价值的双丰收。',
    bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bde58101-df9f-4acf-a278-b7f783989f0e.png',
    bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/05500afe-2f71-4ffb-8000-75365fe72c08.png',
    href: '/advantage?id=1'
  },
  {
    id: 'technology',
    name: '领先技术',
    desc: '掌阅始终注重产品的研发及技术创新，自主研发了数字阅读平台，在业内率先实现了3D仿真翻页、护眼模式等技术创新的产品应用，并在文档识别、转化、续读技术以及数字内容的精装排版等方面形成了核心技术优势，获得多项技术专利。近年来，公司持续探索人工智能与主营业务的融合应用，深入推进 AI+阅读、AI+短剧，优化AI Agent“掌阅书童”，积极利用人工智能提升 IP 的孵化和衍生效率，同时全面提升公司在内容生产、营销推广、产品创新等方面的效率与质量。',
    bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/284b415b-ba85-431b-ac15-4bf0da47d387.png',
    bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/58adae04-f1dd-46bc-9735-b167def3d3fa.png',
    href: '/advantage?id=2'
  },
  {
    id: 'copyright',
    name: '版权保护',
    desc: '掌阅历来重视知识产权保护。为加强内容版权保护，充分保障合作出版机构、内容供应商和作者的版权权益，公司自主研发搭建具有强大版权管理能力和高水平排版编辑能力的版权支撑平台“掌阅作书匠”。该系统具备3重预警机制、16项版权风险识别功能、5种风险应对方案，以及专业化设计、校对、编排及审核能力。公司对字体侵权、商标侵权、作品侵权等知识产权侵权行为进行实时监控，并通过行政途径、司法途径积极维权，取得显著成果，有效打击了各类侵权行为。同时，公司对数字阅读平台软件、电子书排版制作平台软件等自有产品均进行了软件著作权登记，已形成专利、商标、软件著作权、版权全方位的知识产权保护体系。',
    bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/aff9a6d7-2682-4d5e-9e19-62fb1f9b706f.png',
    bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/678e9e20-c761-469a-a006-395f46f152d8.png',
    href: '/advantage?id=3'
  },
  {
    id: 'operation',
    name: '智能运营',
    desc: '掌阅拥有丰富的用户及内容运营经验，坚持精品理念，制作和精选优质的文学和短剧等数字内容，推出适用不同场景的多种终端硬件产品，充分满足用户的阅读和娱乐需求。同时通过大数据技术和算法体系，高效精准地将优质数字内容触达用户，形成了以内容挖掘和用户行为为导向的精细化且高效的数字阅读运营体系。在此基础上公司搭建商业化平台，同时实现了改善用户体验与商业化增值两大目标。近年来，掌阅深入推进人工智能在内部运营各个环节的深度应用，赋能内容生产、素材设计、营销投放、管理决策、客户服务、知识管理等流程，持续降本增效。',
    bg: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/6b865cdc-db0d-4045-8ab0-27b7d5d32602.png',
    bg_wap: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/fa0c55b3-cf27-496b-927d-93e120b0ed7b.png',
    href: '/advantage?id=4'
  }
];

const ABOUT = [
  {
    name: '发展历程',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f5c581ef-bd5f-4b5b-b6e3-24f0dd52e7d6.png',
    href: '/about?id=develop',
    detail: [
      { title: '2008年9月', list: ['掌阅科技股份有限公司正式成立'] },
      { title: '2011年1月', list: ['掌阅APP正式上线'] }
    ]
  },
  {
    name: '企业文化',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d8349a30-4b27-457f-82a9-46c36145d376.png',
    href: '/about?id=culture',
    detail: [
      { title: '使命', list: ['让创作点亮美好时光'] },
      { title: '掌阅范', list: ['自驱敢为， 客观坦诚， 简单高效， 追求极致'] }
    ]
  },
  {
    name: '奖项荣誉',
    icon: 'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/f5c581ef-bd5f-4b5b-b6e3-24f0dd52e7d6.png',
    href: '/about?id=honor',
    detail: [
      {
        title: '',
        list: [
          '中国专利保护协会理事单位',
          '中国版权协会副理事长单位',
          '中国出版协会常务理事单位',
          '中国音像与数字出版协会副理事长单位'
        ]
      }
    ]
  }
];

export {
  ADVANTAGE,
  COPYRIGHT,
  ABOUT,
  DESCRIPTION,
  READING_APPS,
  OVERSEA_APPS,
  RESPONSIBILITY,
  BAR_MENU_STATUS,
  INVESTMENT,
  CULTURE,
  CONTACT,
  SHARE,
  ICP,
  POLICY,
  LABEL,
  NAV
};
